var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return Promise.all([
		__webpack_require__.e(573),
		__webpack_require__.e(9742)
	]).then(next);
};